import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import AlarmCameraVideo from '@blade-sxp/screen/components/camera/alarm-camera-video.vue';
let Device = class Device extends Vue {
    // highlight:string = highlight;
    status = 'ONLINE';
    name = '';
    id;
    dialogVisible = false;
    handleClick(e) {
        // e.preventDefault();
        e.stopPropagation();
        alert('点击事件生效');
        this.dialogVisible = true;
    }
};
Device = __decorate([
    Component({
        name: 'device',
        components: {
            'alarm-camera': AlarmCameraVideo,
        },
    })
], Device);
export default Device;
